import * as React from 'react';
import { Col, Row, ArticleHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import {
  EHelpTextPosition,
  IQuestionLayoutProps,
  getFieldSize,
  FieldWrapper,
} from '@cian/frontend-request-form-widget';

import * as styles from './styles.css';

export const CustomQuestionLayout: React.FC<IQuestionLayoutProps> = props => {
  const { question, error, actions, fieldMapper, above } = props;

  return (
    <div className={styles['container']} data-testid="questionLayout">
      <div>
        <ArticleHeading2>{question.title}</ArticleHeading2>
      </div>
      {question.helpText?.position === EHelpTextPosition.Above && (
        <div className={styles['description']}>
          <UIText1 color="black_100" display="inline">
            {question.helpText.text}
          </UIText1>
        </div>
      )}
      {above && <div className={styles['above']}>{above}</div>}
      <div className={styles['answer']}>
        <Row>
          {question.fields.map(field => {
            const FieldComponent = fieldMapper(field.type);

            return (
              <Col key={field.name} {...getFieldSize(field)}>
                <FieldWrapper>
                  <FieldComponent {...field} />
                </FieldWrapper>
              </Col>
            );
          })}
        </Row>
      </div>
      {actions && <div className={styles['actions']}>{actions}</div>}
      {error && (
        <div className={styles['error']} data-testid="error">
          <UIText2 display="inline" color="error_100">
            {error}
          </UIText2>
        </div>
      )}
      {question.helpText?.position === EHelpTextPosition.Below && (
        <div className={styles['footer']} data-testid="footer">
          {question.helpText.text}
        </div>
      )}
    </div>
  );
};

CustomQuestionLayout.displayName = 'CustomQuestionLayout';
